import React from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { getSlug, } from "../../../../src/config/routes/guards/slug";
// import { formatDate } from '../../../helpers/formatDate';
// import Dropdown from 'react-bootstrap/Dropdown';
import { IconArrowLeft, IconZoomIn, IconFileExport } from "@tabler/icons-react";
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";

const DatatablePps = (props) => {
  // console.log(props?.role);
  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const handleOpenNewTab = (path) => {
    let base = getSlug() ? `/hospitals/${getSlug()}` : '';
    // Remove leading slash from path to avoid double slashes
    let cleanedPath = path.startsWith('/') ? path : `/${path}`;
    // Avoid duplicating the hospitals/slug if path already contains it
    if (cleanedPath.startsWith(base)) {
      window.open(cleanedPath, "_blank");
    } else {
      window.open(base + cleanedPath, "_blank");
    }
  };

  const columns = [
    {
      name: "Aksi",
      minWidth: "100px", // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <button
            className="btn btn-outline-danger btn-sm"
            type="button"
            title="Item PPS"
            onClick={() => handleOpenNewTab(`/pps-item/${row.id}`)}
          >
            <IconZoomIn stroke={2} />
          </button>
        </>
      ),
    },
    {
      name: "Standar",
      minWidth: "100px", // Set a minimum width for horizontal scroll
      selector: (row) =>
        row?.variables_accreditation?.elements_accreditation?.Nomor,
    },
    {
      name: "Elemen Penilaian",
      minWidth: "250px", // Set a minimum width for horizontal scroll
      // selector: (row) => row?.elements_accreditation?.Deskripsi,
      cell: (row) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
          {row?.variables_accreditation?.Abjad}.{" "}
          {row?.variables_accreditation?.Deskripsi}
        </div>
      ),
      style: {
        // You can also add more styles here
        whiteSpace: "normal",
      },
    },
    // {
    //   name: "Fakta Analisis",
    //   width: "250px",
    //   // selector: (row) => row?.faktaAnalisis,
    //   cell: (row) => (
    //     <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
    //       {row?.faktaAnalisis}
    //     </div>
    //   ),
    //   style: {
    //     // You can also add more styles here
    //     whiteSpace: "normal",
    //   },
    // },
    {
      name: "Fakta Analisis",
      minWidth: "250px", // Set a minimum width for horizontal scroll
      // selector: (row) => row?.rekomendasiLipa,
      cell: (row) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
          {row?.faktaAnalisisLipa}
        </div>
      ),
      style: {
        // You can also add more styles here
        whiteSpace: "normal",
      },
    },
    {
      name: "Rekomendasi",
      minWidth: "250px", // Set a minimum width for horizontal scroll
      // selector: (row) => row?.rekomendasiLipa,
      cell: (row) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
          {row?.rekomendasiLipa}
        </div>
      ),
      style: {
        // You can also add more styles here
        whiteSpace: "normal",
      },
    },
    // {
    //   name: "Status",
    //   cell: (row) => (
    //     <>
    //       {row.statusPps === 0 ? (
    //         <span type="button" className="badge badge-danger">
    //           Pending by Surveior
    //         </span>
    //       ) : row.statusPps === 1 ? (
    //         <span type="button" className="badge badge-primary">
    //           Solved by Surveior
    //         </span>
    //       ) : row.statusPps === 2 ? (
    //         <span type="button" className="badge badge-success">
    //           Checked by KPPA
    //         </span>
    //       ) : (
    //         <span type="button" className="badge badge-warning">
    //           Belum Review
    //         </span>
    //       )}
    //     </>
    //   ),
    // },
  ];

  const customStyles = {
    rows: {
      style: {
        marginBottom: "25px", // Adjust this value for bottom margin
      },
    },
  };

  return (
    <>
      <div className="d-flex justify-content-between mt-8">
        <h5 className="card-title">Daftar Rekomendasi Survei</h5>
        <div>
          {props.role === "Kelompok Kerja" ||
            props.role === "Surveior Internal" ? (
            <>
              <button
                className="btn btn-sm btn-outline-success m-3"
                type="button"
                title="Export Items Pps"
                onClick={() => props.handleExportItemsPps()}
              >
                <IconFileExport stroke={2} /> Export Item PPS
              </button>
              <button
                className="btn btn-sm btn-outline-primary m-3"
                type="button"
                title="Export Dokumen Pps"
                onClick={() => props.handleExportDokumenItemsPps()}
              >
                <IconFileExport stroke={2} /> Export Dokumen
              </button>
            </>
          ) : (
            ""
          )}

          <button
            onClick={() => handleChangePage("/accreditation")}
            className="btn btn-sm btn-info m-3"
          >
            <IconArrowLeft stroke={2} /> Kembali
          </button>
        </div>
      </div>
      <div style={{ overflowX: "auto", maxWidth: "1200px" }}>
        <DataTable
          columns={columns}
          customStyles={customStyles}
          data={props.recommendations}
          pagination
          fixedHeader
          highlightOnHover
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="Search"
              className="w-50 form-control m-3"
              values={props.search}
              onChange={(e) => {
                // Hanya izinkan huruf, angka, dan spasi
                const cleanValue = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                props.handleChangeSearch(cleanValue);
              }}
            />
          }
          subHeaderAlign="center"
        />
      </div>
    </>
  );
};

export default DatatablePps;
